import { Button } from 'reactstrap';
import React, { useState } from 'react';
import AddSecurityCodeModal from './AddSecurityCodeModal';

const NotAssessableCommon = ({ onSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  return (
    <div className="text-center">
      <div className="my-5">
        <div className="lead">Unable To access this page</div>
        <p>You cannot access this page untill you enter the right password</p>
      </div>
      <Button color="primary" onClick={() => setIsModalOpen(true)}>
        Enter Password
      </Button>

      <AddSecurityCodeModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={() => {
          onSuccess(false)
          setIsModalOpen(false);
        }}
        featureName={"adminDash"}
      />
    </div>
  );
}

export default NotAssessableCommon;

